import { useNavigation } from "@react-navigation/native";
import { useContext, useEffect, useState } from "react";
import { AppState, StyleSheet, Text, View } from "react-native";
import QRCodeStyled from "react-native-qrcode-styled";
import "text-encoding-polyfill";
import PageTitle from "../../../../components/PageTitle";
import CircularProgress from "./components/CircularProgress";
import { GetUserById, GetUserQRCode } from "../../../../services/Api/user";
import { GlobalContext } from "../../../../contexts/global";
import { formatDocument } from "../../../../helpers/util";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import { Colors } from "../../../../styles";

const EXPIRE_COUNTER = 30;
const MAX_ATTEMP = 5;
const INVALID = "Inválido";

export default function DigitalCredential() {
  const [showValue, setShowValue] = useState(false);
  const { setLoading, setShowAlert, showAlert } = useContext(GlobalContext);
  const [counter, setCounter] = useState(EXPIRE_COUNTER);
  const [dataQR, setDataQR] = useState(INVALID);
  const [userData, setUserData] = useState({});
  const [attemp, setAttemp] = useState(MAX_ATTEMP);
  const navigation = useNavigation();

  useEffect(() => {
    const handleAppStateChange = (nextAppState) => {
      if (nextAppState === "active") {
        navigation.replace("DigitalCredential");
      }
    };

    const subscription = AppState.addEventListener("change", handleAppStateChange);
    return () => {
      subscription.remove();
    };
  }, []);

  useEffect(
    () =>
      setLoading({
        show: true,
        message: "Carregando sua credencial",
      }),
    []
  );

  useEffect(() => {
    const interval = setInterval(() => {
      if (counter > 0) {
        setCounter(counter - 1);
      }
      if (counter === 0) {
        clearInterval(interval);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [counter]);

  useEffect(() => {
    (async () => {
      GetUserById()
        .then((value) => {
          setUserData(value);
          setLoading({ show: false, message: "" });
        })
        .catch((error) => {
          setShowAlert({
            type: "alert",
            title: "Atenção",
            message: "Ocorreu um erro ao retornar os seus dados.",
            show: true,
            confirmText: "Tentar Novamente",
            pressConfirm: () => {
              navigation.goBack();
            },
          });
        })
        .finally(() => setLoading({ show: false, message: "" }));
    })();

    getQRCode();
  }, []);

   const getQRCode = async () => {
    GetUserQRCode()
      .then((value) => {
        setDataQR(value.content);
        setLoading({ show: false, message: "" });
      })
      .catch((error) => {
        setShowAlert({
          type: "alert",
          title: "Atenção",
          message: "Ocorreu um erro ao retornar os seus dados.",
          show: true,
          confirmText: "Tentar Novamente",
          pressConfirm: () => {
            navigation.goBack();
          },
        });
      })
      .finally(() => setLoading({ show: false, message: "" }));
  }

  useEffect(() => {
    if (counter === 0 && attemp > 0) {
      getQRCode().finally(() => {
        setCounter(EXPIRE_COUNTER)
        setAttemp(attemp - 1)
      });
    }
  }, [counter]);

  useEffect(()=>{
    if(attemp == 0){
      setDataQR(INVALID)
      setShowAlert({
        type: "alert",
        title: "Atenção",
        message: "Máximo de tentativas permitido da credencial digital. Por favor acesse novamente",
        show: true,
        confirmText: "OK",
        pressConfirm: () => {
          setShowAlert({ ...showAlert, show: false });
          navigation.goBack();
        },
      });
    }
  },[attemp])

  return (
    <PageTitle title={"Credencial Digital"} navigation={useNavigation()}>
      <View style={styles.container}>
        <View>
          <Text style={styles.textName}>
            {userData.name ?? "Não encontrado"}
          </Text>
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Text style={styles.textDocument}>
              {userData.document
                ? formatDocument(userData.document, !showValue)
                : "Não encontrado"}
            </Text>
            <Icon
              name={showValue ? "eye-outline" : "eye-off-outline"}
              color={Colors.BLACK}
              size={24}
              style={{ marginLeft: "auto" }}
              onPress={() => setShowValue(!showValue)}
            />
          </View>
        </View>
        <View>
          {dataQR == INVALID ? null : <QRCodeStyled data={dataQR} padding={24} pieceSize={8} />}
        </View>
        <View style={styles.circularProgressView}>
          <CircularProgress
            duration={EXPIRE_COUNTER}
            loop
            setTimeLeft={setCounter}
            timeLeft={counter}
          />
          <Text
            style={styles.textQR}
          >{`Aproxime esse QR Code\nno Totem de Entrada/Saida.`}</Text>
        </View>
      </View>
    </PageTitle>
  );
}
const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    flex: 1,
    justifyContent: "space-evenly",
    padding: 8,
  },
  circularProgressView: {
    alignItems: "center",
    margin: 10,
  },
  textQR: {
    fontSize: 16,
    marginTop: 8,
    textAlign: "center",
  },
  textName: {
    fontSize: 20,
    textAlign: "center",
    fontWeight: "500",
  },
  textDocument: {
    fontSize: 24,
    textAlign: "center",
    fontWeight: "500",
    marginRight: 8,
  },
});
